
const logoUrl = "https://firebasestorage.googleapis.com/v0/b/what-was-it-gc-fb-56459.firebasestorage.app/o/just%20logo%20(3).png?alt=media&token=26a5639a-6fc9-4f91-b8f5-9364e25ad307";

export { logoUrl };
